@file:OptIn(InternalResourceApi::class)

package villawonka.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/villawonka.composeapp.generated.resources/"

internal val Res.drawable.category_exchange: DrawableResource by lazy {
      DrawableResource("drawable:category_exchange", setOf(
        ResourceItem(setOf(), "${MD}drawable/category_exchange.png", -1, -1),
      ))
    }

internal val Res.drawable.category_housing: DrawableResource by lazy {
      DrawableResource("drawable:category_housing", setOf(
        ResourceItem(setOf(), "${MD}drawable/category_housing.png", -1, -1),
      ))
    }

internal val Res.drawable.category_transport: DrawableResource by lazy {
      DrawableResource("drawable:category_transport", setOf(
        ResourceItem(setOf(), "${MD}drawable/category_transport.png", -1, -1),
      ))
    }

internal val Res.drawable.category_visa: DrawableResource by lazy {
      DrawableResource("drawable:category_visa", setOf(
        ResourceItem(setOf(), "${MD}drawable/category_visa.png", -1, -1),
      ))
    }

internal val Res.drawable.header_logo: DrawableResource by lazy {
      DrawableResource("drawable:header_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/header_logo.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_arrow_up_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_up_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_up_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_chat_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_chat_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_chat_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_circle_question_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_circle_question_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_circle_question_16.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_close_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_close_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_close_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_congrats: DrawableResource by lazy {
      DrawableResource("drawable:ic_congrats", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_congrats.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_currency_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_currency_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_currency_16.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_currency_cny_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_currency_cny_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_currency_cny_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_currency_idr_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_currency_idr_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_currency_idr_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_currency_rub_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_currency_rub_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_currency_rub_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_currency_usd_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_currency_usd_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_currency_usd_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_expand_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_expand_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_expand_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_eye_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_eye_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_eye_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_filter_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_filter_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_filter_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_globe_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_globe_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_globe_16.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_heart_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_heart_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_heart_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_heart_outline_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_heart_outline_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_heart_outline_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_indonesia: DrawableResource by lazy {
      DrawableResource("drawable:ic_indonesia", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_indonesia.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_logo: DrawableResource by lazy {
      DrawableResource("drawable:ic_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_logo.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_logo_140: DrawableResource by lazy {
      DrawableResource("drawable:ic_logo_140", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_logo_140.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_map_pin_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_map_pin_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_map_pin_16.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_nav_arrow_down_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_arrow_down_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_arrow_down_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_nav_arrow_left_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_arrow_left_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_arrow_left_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_nav_arrow_up_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_nav_arrow_up_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_nav_arrow_up_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_newspaper_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_newspaper_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_newspaper_16.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_plus_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_plus_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_plus_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_search_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_search_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_search_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_settings_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_settings_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_settings_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_share_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_share_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_share_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_sort_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_sort_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_sort_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_telegram_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_telegram_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_telegram_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_thailand: DrawableResource by lazy {
      DrawableResource("drawable:ic_thailand", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_thailand.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_verification_16: DrawableResource by lazy {
      DrawableResource("drawable:ic_verification_16", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_verification_16.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_vietnam: DrawableResource by lazy {
      DrawableResource("drawable:ic_vietnam", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_vietnam.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_warning_circle_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_warning_circle_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_warning_circle_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.ic_yuan_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_yuan_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_yuan_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.is_sort_24: DrawableResource by lazy {
      DrawableResource("drawable:is_sort_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/is_sort_24.xml", -1, -1),
      ))
    }

internal val Res.drawable.stub_error: DrawableResource by lazy {
      DrawableResource("drawable:stub_error", setOf(
        ResourceItem(setOf(), "${MD}drawable/stub_error.xml", -1, -1),
      ))
    }

internal val Res.drawable.stub_no_connection: DrawableResource by lazy {
      DrawableResource("drawable:stub_no_connection", setOf(
        ResourceItem(setOf(), "${MD}drawable/stub_no_connection.xml", -1, -1),
      ))
    }

internal val Res.drawable.stub_no_favorites: DrawableResource by lazy {
      DrawableResource("drawable:stub_no_favorites", setOf(
        ResourceItem(setOf(), "${MD}drawable/stub_no_favorites.xml", -1, -1),
      ))
    }

internal val Res.drawable.stub_no_filters: DrawableResource by lazy {
      DrawableResource("drawable:stub_no_filters", setOf(
        ResourceItem(setOf(), "${MD}drawable/stub_no_filters.xml", -1, -1),
      ))
    }

internal val Res.drawable.stub_no_search_results: DrawableResource by lazy {
      DrawableResource("drawable:stub_no_search_results", setOf(
        ResourceItem(setOf(), "${MD}drawable/stub_no_search_results.xml", -1, -1),
      ))
    }

internal val Res.drawable.stub_tech_works: DrawableResource by lazy {
      DrawableResource("drawable:stub_tech_works", setOf(
        ResourceItem(setOf(), "${MD}drawable/stub_tech_works.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("category_exchange", Res.drawable.category_exchange)
  map.put("category_housing", Res.drawable.category_housing)
  map.put("category_transport", Res.drawable.category_transport)
  map.put("category_visa", Res.drawable.category_visa)
  map.put("header_logo", Res.drawable.header_logo)
  map.put("ic_arrow_up_24", Res.drawable.ic_arrow_up_24)
  map.put("ic_chat_24", Res.drawable.ic_chat_24)
  map.put("ic_circle_question_16", Res.drawable.ic_circle_question_16)
  map.put("ic_close_24", Res.drawable.ic_close_24)
  map.put("ic_congrats", Res.drawable.ic_congrats)
  map.put("ic_currency_16", Res.drawable.ic_currency_16)
  map.put("ic_currency_cny_24", Res.drawable.ic_currency_cny_24)
  map.put("ic_currency_idr_24", Res.drawable.ic_currency_idr_24)
  map.put("ic_currency_rub_24", Res.drawable.ic_currency_rub_24)
  map.put("ic_currency_usd_24", Res.drawable.ic_currency_usd_24)
  map.put("ic_expand_24", Res.drawable.ic_expand_24)
  map.put("ic_eye_24", Res.drawable.ic_eye_24)
  map.put("ic_filter_24", Res.drawable.ic_filter_24)
  map.put("ic_globe_16", Res.drawable.ic_globe_16)
  map.put("ic_heart_24", Res.drawable.ic_heart_24)
  map.put("ic_heart_outline_24", Res.drawable.ic_heart_outline_24)
  map.put("ic_indonesia", Res.drawable.ic_indonesia)
  map.put("ic_logo", Res.drawable.ic_logo)
  map.put("ic_logo_140", Res.drawable.ic_logo_140)
  map.put("ic_map_pin_16", Res.drawable.ic_map_pin_16)
  map.put("ic_nav_arrow_down_24", Res.drawable.ic_nav_arrow_down_24)
  map.put("ic_nav_arrow_left_24", Res.drawable.ic_nav_arrow_left_24)
  map.put("ic_nav_arrow_up_24", Res.drawable.ic_nav_arrow_up_24)
  map.put("ic_newspaper_16", Res.drawable.ic_newspaper_16)
  map.put("ic_plus_24", Res.drawable.ic_plus_24)
  map.put("ic_search_24", Res.drawable.ic_search_24)
  map.put("ic_settings_24", Res.drawable.ic_settings_24)
  map.put("ic_share_24", Res.drawable.ic_share_24)
  map.put("ic_sort_24", Res.drawable.ic_sort_24)
  map.put("ic_telegram_24", Res.drawable.ic_telegram_24)
  map.put("ic_thailand", Res.drawable.ic_thailand)
  map.put("ic_verification_16", Res.drawable.ic_verification_16)
  map.put("ic_vietnam", Res.drawable.ic_vietnam)
  map.put("ic_warning_circle_24", Res.drawable.ic_warning_circle_24)
  map.put("ic_yuan_24", Res.drawable.ic_yuan_24)
  map.put("is_sort_24", Res.drawable.is_sort_24)
  map.put("stub_error", Res.drawable.stub_error)
  map.put("stub_no_connection", Res.drawable.stub_no_connection)
  map.put("stub_no_favorites", Res.drawable.stub_no_favorites)
  map.put("stub_no_filters", Res.drawable.stub_no_filters)
  map.put("stub_no_search_results", Res.drawable.stub_no_search_results)
  map.put("stub_tech_works", Res.drawable.stub_tech_works)
}
